import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_27yaz87n28: FaireBrandEntity = {
  token: "b_27yaz87n28",
  type: "brand",
  name: "Coop's",
  avatarUrl:
    "https://cdn.faire.com/fastly/6015abad116798af89f8fe2eb13470bf12d5e4fa26d85ac2d76da8956afb4bea.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ce32f86d408ffb5e397854d18f53950e1c4e1e67ce3bbc2048cf1f81410ace15.png",
  logoUrl:
    "https://cdn.faire.com/fastly/6015abad116798af89f8fe2eb13470bf12d5e4fa26d85ac2d76da8956afb4bea.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ce32f86d408ffb5e397854d18f53950e1c4e1e67ce3bbc2048cf1f81410ace15.png",
  location: "Boston, MA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 44,
  isTopShop: true,
  isInsider: true,
  description:
    "For over a decade, Coop’s has studied and tested each ingredient that goes into our toppings until deemed fit for perfection. Coop's has achieved a new level of richness and smoothness that’s purely all-natural. Our curated recipes are handmade in small batches, and proud winners of multiple SOFI awards. \n",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:22.856Z",
    importedBy: "entity-db-cli",
  },
};
